import * as React from 'react';
import ButtonIcon from './ButtonIcon';

const IconClose: React.FC<any> = () => {
    return (

        <ButtonIcon
            color={'lightgray'}
            size={'1.4rem'}
            icon={'fa-times'}
            mask={'fa-square'}
            shrink={7}
        />
    );
};
export default IconClose;